(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rk-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rk-tabs-block-element')) {
    class RkTabsBlockElement extends HTMLElement {
      connectedCallback() {
        this._moveTriggers();
        this._init();
      }

      /* Move trigger buttons rendered by child blocks into the tablist */
      _moveTriggers() {
        const tablist = this.querySelector('[role="tablist"]');
        if (!tablist) return;
        const triggers = this.querySelectorAll('.rk-tabs__content-wrapper [role="tab"]');
        triggers.forEach(function (trigger) {
          tablist.appendChild(trigger);
        });
      }

      _init() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (this.tabs.length === 0 || this.panels.length === 0) return;

        this._setupA11y();
        this._bindEvents();

        /* Activate first tab */
        var first = this.tabs[0];
        if (first) this._activateTab(first.id, false);
      }

      _setupA11y() {
        this.tabs.forEach(function (tab) {
          tab.setAttribute('tabindex', '-1');
          tab.setAttribute('aria-selected', 'false');
        });
        this.panels.forEach(function (panel) {
          panel.setAttribute('tabindex', '0');
          panel.setAttribute('hidden', 'true');
        });
      }

      _bindEvents() {
        var self = this;
        var tablist = this.querySelector('[role="tablist"]');
        if (!tablist) return;

        tablist.addEventListener('click', function (e) {
          var target = e.target.closest('[role="tab"]');
          if (!target || target.disabled) return;
          self._activateTab(target.id, true);
        });

        tablist.addEventListener('keydown', function (e) {
          self._onKeyDown(e);
        });
      }

      _activateTab(tabId, focus) {
        this.tabs.forEach(function (tab) {
          var isSelected = tab.id === tabId;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
          if (isSelected && focus) tab.focus();
        });

        this.panels.forEach(function (panel) {
          if (panel.getAttribute('aria-labelledby') === tabId) {
            panel.removeAttribute('hidden');
            panel.classList.add('rk-tabs__panel--active');
          } else {
            panel.setAttribute('hidden', 'true');
            panel.classList.remove('rk-tabs__panel--active');
          }
        });

        this.dispatchEvent(
          new CustomEvent('rk:tabs:change', {
            bubbles: true,
            detail: { activeTabId: tabId },
          })
        );
      }

      _onKeyDown(e) {
        var target = e.target.closest('[role="tab"]');
        if (!target) return;

        var idx = this.tabs.indexOf(target);
        var next = idx;
        var orient = this.dataset.orientation || 'horizontal';

        switch (e.key) {
          case 'ArrowRight':
            if (orient === 'horizontal') next = idx + 1;
            break;
          case 'ArrowLeft':
            if (orient === 'horizontal') next = idx - 1;
            break;
          case 'ArrowDown':
            if (orient === 'vertical') next = idx + 1;
            break;
          case 'ArrowUp':
            if (orient === 'vertical') next = idx - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = this.tabs.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        if (next >= this.tabs.length) next = 0;
        else if (next < 0) next = this.tabs.length - 1;

        this.tabs[next].focus();
        this._activateTab(this.tabs[next].id, true);
      }
    }

    customElements.define('rk-tabs-block-element', RkTabsBlockElement);
  }
  } catch(e) { console.error(e); }
})();

})();
